import {START_LOCATION} from 'vue-router'
import originalSidebar from 'src/const/layouts'
import Axios from "axios";

// ケバブケースをキャメルケースに変換
function toCamelCase(str) {
  // 基本的には code: camelCase, url: kebab-case で対応しているのでキャメルケースに変換すれば良いのだが、
  // 一部その対応になってない人たちがいるのでそちらについては無理やり変換（layout.js参照）。
  if(str === "scatter"){
    return "Scatter"
  }else if(str === "trendGraph"){
    return "TrendGraph"
  }else if(str === "continuous-total"){
    return "continuous_total"
  }else if(str === "operating-history"){
    return "operationHistory"
  } else if (str === "FacePlate") {
    // フェースプレートだけ特例で、グラフィックのメニュー表示設定が入っているかどうかで判定を行う。
    return "graphic"
  }else{
    return str.split('-').map(function(word,index){
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
  }
}

/** URLで指定した先が階層設定でメニュー表示設定されていない場合はアクセスをブロック */
async function validateUrlAccess(to, from) {
  // ブラウザにURL直打ちのケースとログイン後の初期画面表示のケースのみチェックを行う
  if (from === START_LOCATION || from?.fullPath === '/auth/mfa') {
    const nodeId = to.params.nodeId
    const localVarPath = `/swc-api/master/simple-nodes/${nodeId}`
    const parentUrl = `/node/${nodeId}/`

    const getRouteName = (routeInfo) => {
      const routeMapToParent = {
        'camera-image-detail': 'camera-image'
      }
      return toCamelCase(routeMapToParent[routeInfo.name] ?? routeInfo.name);
    }

    const getRouteUrl = (routeInfo) => {
      let url = routeInfo.path
      if (url.substr(-1) === "/") {
        // url の末尾が / の場合取り除く
        url = url.slice(0, url.length - 1);
      }

      if (url.endsWith('camera-detail')) {
        url = url.split("/").slice(0, -2).join("/");
      }

      // フェースプレートだけ特例で、グラフィックのメニュー表示設定が入っているかどうかで判定を行う。
      if (url.endsWith("face-plate")) {
        url = url.replace("face-plate", "graphic")
      }

      return url;
    }

    const isMenuAccessible = (nodeData) => {
      const dispList = nodeData.menu_display_setting ?? {}
      // TODO better implemention for nested route validation
      let url = getRouteUrl(to);
      let routeName = getRouteName(to);
      return originalSidebar.some(value => {
        if (value.children.length > 0) {
          return value.children.some(child => {
            const requirement = child.requirement
            let isReqOk = requirement ? nodeData[requirement] !== null && nodeData[requirement] !== undefined && nodeData[requirement].length > 0 : true
            if (isReqOk) {
              if (dispList[routeName] && url === parentUrl + child.url) {
                return true;
              }
            }
            return false;
          })
        } else {
          const requirement = value.requirement
          let isReqOk = requirement ? nodeData[requirement] !== null && nodeData[requirement] !== undefined && nodeData[requirement].length > 0 : true
          if (isReqOk) {
            if (dispList[routeName] && to.path === parentUrl + value.url) {
              return true;
            }
          }
          return false;
        }
      })
    }

    const menuDisplayChecker = async () => {
      // axios.js の http だと400番台や500番台が帰ってきたときに画面下部にエラーバナーが表示されてしまう。
      // ここでは万が一エラーが出れた場合でもバナーを出さず何事もなかったかのようにすぐにトップ画面へ遷移したいので、
      // 自前のAxiosInstanceを作成する。
      const customHttp = Axios.create({
          baseURL: '/',
          withCredentials: true,
          headers: {
              "Content-Type": "application/json; charset=UTF-8",
              "X-Requested-With": "XMLHttpRequest"
          }
      });
      customHttp.interceptors.response.use(
        config => {
            const token = localStorage.getItem('auth/ACCESS_TOKEN')
            config.headers['Authorization'] = 'Bearer ' + token
            return config
        }
      );
      return customHttp({
        url: localVarPath,
        method: 'GET',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('auth/ACCESS_TOKEN')}`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(d => {
          return isMenuAccessible(d.data)
        }).catch(e => {
          console.log(e)
          return false;
        })
    }

    const isAccessible = await menuDisplayChecker();
    if (!isAccessible) {
      // ログイン後の初期画面表示でいちいち警告メッセージ出していると煩わしいので出さない。
      if (from?.fullPath !== '/auth/mfa') {
        alert("不正な URL が指定されたので、TOPページに移動します。")
      }
      return "/top";
    }
  }
}

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'top',
        name: 'top',
        component: () => import('pages/Top.vue'),
        meta: {title: 'トップ', type: 'user'},
      },
      {
        path: 'node/:nodeId/scatter',
        name: 'scatter',
        component: () => import('pages/Scatter.vue'),
        meta: {title: '統計データ分析', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/dashboard',
        name: 'dashboard',
        component: () => import('pages/Dashboard.vue'),
        meta: {title: 'ダッシュボード', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/long-trend',
        name: 'longTrend',
        component: () => import('pages/LongTrend.vue'),
        meta: {title: '長期トレンド', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/trend-graph',
        name: 'trendGraph',
        component: () => import('pages/TrendGraph.vue'),
        meta: {title: 'トレンドグラフ', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/camera-image',
        name: 'camera-image',
        component: () => import('pages/CameraImage.vue'),
        meta: {title: 'カメラ画像', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/camera-image/:cameraId/camera-detail',
        name: 'camera-image-detail',
        component: () => import('pages/CameraImageDetail.vue'),
        meta: {title: 'カメラ画像詳細', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/camera-ai-model-setting/',
        name: 'camera-ai-model-settings',
        component: () => import('pages/CameraAIModelSetting'),
        meta: {title: 'モデル設定', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/camera-ai-model-deploy/',
        name: 'camera-ai-model-deploy',
        component: () => import('pages/CameraAIModelDeploy'),
        meta: {title: 'デプロイ設定', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/saicrew-ai-model-setting/',
        name: 'saicrew-ai-model-settings',
        component: () => import('pages/SaicrewAIModelSetting'),
        meta: {title: 'モデル設定', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/saicrew-ai-model-deploy/',
        name: 'saicrew-ai-model-deploy',
        component: () => import('pages/SaicrewAIModelDeploy'),
        meta: {title: 'デプロイ設定', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/alarm-history',
        name: 'alarm-history',
        component: () => import('pages/AlarmHistory.vue'),
        meta: {title: '警報履歴', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/technical-report',
        name: 'technical-report',
        component: () => import('pages/TechnicalReport.vue'),
        meta: {title: 'テクニカルレポート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/mbr-report',
        name: 'mbr-report',
        component: () => import('pages/TechnicalReportIndex.vue'),
        meta: {title: 'テクニカルレポート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/mbr-report/calculation_no/:calculationNo',
        name: 'mbr-report-detail',
        component: () => import('pages/TechnicalReportDetail.vue'),
        meta: {title: 'テクニカルレポート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/ro-report',
        name: 'ro-report',
        component: () => import('pages/RoReport.vue'),
        meta: {title: 'ROテクニカルレポート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/saiforce-report',
        name: 'SaiForce-report',
        component: () => import('pages/SaiForceReport.vue'),
        meta: {title: 'SaiForceレポート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/chohyo',
        name: 'chohyo',
        component: () => import('pages/Chohyo.vue'),
        meta: {title: '帳票', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/csv-download',
        name: 'csv-download',
        component: () => import('pages/CsvDownload.vue'),
        meta: {title: '一括データ出力', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/csv-upload',
        name: 'csv-upload',
        component: () => import('pages/CsvUpload.vue'),
        meta: {title: '一括データ入力', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/integration-timer',
        name: 'continuous-total',
        component: () => import('pages/ContinuousTotal.vue'),
        meta: {title: '連続時間積算', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/integration-timer-history',
        name: 'continuous-total-history',
        component: () => import('pages/ContinuousTotalHistory.vue'),
        meta: {title: '連続時間積算履歴', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/operating-history',
        name: 'operating-history',
        component: () => import('pages/OperatingHistory.vue'),
        meta: {title: '運転履歴', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/maintenance-history',
        name: 'maintenance-history',
        component: () => import('pages/MaintenanceHistory.vue'),
        meta: {title: 'シンプル記録', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/plant-detail/:plantDetailId',
        name: 'plant-detail',
        component: () => import('pages/PlantDetail.vue'),
        meta: {title: 'プラント詳細', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/latest-status',
        name: 'latest-status',
        component: () => import('pages/LatestStatus.vue'),
        meta: {title: '最新値一覧', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/operating-summary',
        name: 'operating-summary',
        component: () => import('pages/OperatingSummary.vue'),
        meta: {title: '稼働状況', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/basic-info',
        name: 'node-detail',
        component: () => import('pages/NodeBasicInfo.vue'),
        meta: {title: '基本設定', type: 'user'},
      },
      {
        path: 'node/:nodeId/document-management',
        name: 'document-management',
        component: () => import('pages/DocumentManagement.vue'),
        meta: {title: 'ドキュメント管理', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/monitoring-preference',
        name: 'monitoring-preference',
        component: () => import('pages/MonitoringPreference.vue'),
        meta: {title: 'クラウド設定警報', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/graphic',
        name: 'graphic',
        component: () => import('pages/Graphic.vue'),
        meta: {title: 'グラフィック', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/graphic-record',
        name: 'graphic-record',
        component: () => import('pages/GraphicRecord.vue'),
        meta: {title: 'グラフィックレコーダ', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/remote-control-history',
        name: 'remote-control-history',
        component: () => import('pages/RemoteControlHistory.vue'),
        meta: {title: '遠隔操作履歴', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'node/:nodeId/face-plate',
        name: 'FacePlate',
        component: () => import('pages/FacePlate.vue'),
        meta: {title: 'フェースプレート', type: 'user'},
        beforeEnter: validateUrlAccess
      },
      {
        path: 'error',
        component: () => import('pages/Error404.vue'),
        name: 'error-404',
        meta: {title: '404'}
      },
    ]
  },
  {
    path: '/admin',
    middleware: 'admin',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'user',
        name: 'admin-user',
        component: () => import('pages/admin/users/UserIndex'),
        meta: {title: 'ユーザー管理'}
      },
      {
        path: 'node/',
        name: 'admin-node',
        component: () => import('pages/admin/nodes/NodeIndex'),
        meta: {title: '階層管理'}
      },
      {
        path: 'camera/',
        name: 'admin-camera',
        component: () => import('pages/admin/cameras/CameraIndex'),
        meta: {title: 'カメラ管理'}
      },
      {
        path: 'device/',
        name: 'admin-device',
        component: () => import('pages/admin/devices/DeviceIndex'),
        meta: {title: 'デバイス管理'}
      },
      {
        path: 'patlite/',
        name: 'admin-patlite',
        component: () => import('pages/admin/patlites/PatliteIndex'),
        meta: {title: 'パトランプ管理'}
      },
      {
        path: 'news/',
        name: 'admin-news',
        component: () => import('pages/admin/news/NewsIndex'),
        meta: {title: 'お知らせ管理'}
      },
      {
        path: 'gateway-if/',
        name: 'admin-gatewayIF',
        component: () => import('pages/admin/gateway-if/GatewayIFIndex'),
        meta: {title: 'Gateway変換設定'}
      },
      {
        path: 'recreate-data/',
        name: 'admin-recreateData',
        component: () => import('pages/admin/recreate-data/RecreateDataIndex'),
        meta: {title: '逆転データ修復'}
      },
      {
        path: 'export-bi/',
        name: 'admin-exportBi',
        component: () => import('pages/admin/export-bi/ExportBiIndex'),
        meta: {title: '外部DB出力設定'}
      },
    ]
  },
  {
    path: '/error',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '401',
        name: 'error-401',
        component: () => import('pages/Error401'),
        meta: {title: 'エラー'}
      }
    ]
  },
  {
    path: '/auth',
    redirect: '/auth/login',
    component: () => import('layouts/Auth.vue'),
    children: [
      {
        path: 'login',
        name: 'auth-login',
        component: () => import('pages/Login.vue'),
        meta: {title: 'ログイン'}
      },
      {
        path: 'mfa',
        name: 'auth-mfa',
        component: () => import('pages/Mfa.vue'),
        meta: {title: 'ログイン'}
      },
            {
        path: 'email-auth',
        name: 'auth-email-auth',
        component: () => import('pages/EmailAuth.vue'),
        meta: {title: 'メールアドレス認証'}
      },
      {
        path: 'forget',
        name: 'auth-forget',
        component: () => import('pages/Forget.vue'),
        meta: {title: 'パスワードをお忘れの方'}
      },
      {
        path: 'reissue',
        name: 'auth-reissue',
        component: () => import('pages/Reissue.vue'),
        meta: {title: 'パスワード再発行'}
      },
      {
        path: 'reset',
        name: 'auth-reset',
        component: () => import('pages/Reset.vue'),
        meta: {title: 'パスワード再設定'}
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
    name: 'error-404',
    meta: {title: '404'}
  },

]

export default routes
